import { render, staticRenderFns } from "./_bottom.vue?vue&type=template&id=897f5378&"
import script from "./_bottom.vue?vue&type=script&lang=js&"
export * from "./_bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports